import {
  CHANGE_ACTIVE_ITEM_TS_EXPERT,
  CHANGE_ACTIVE_ITEM_CONFIG,
  SOLVE_PROBLEM,
  // ----------------------- Protocol ----------------------------
  CHANGE_ACTIVE_ITEM_PROTOCOL_RESUME,
  CHANGE_ACTIVE_ITEM_PROTOCOL_LIVELIST,
  CHANGE_ACTIVE_ITEM_PROTOCOL_LIVELIST_MATRIX,
  CHANGE_ACTIVE_ITEM_PROTOCOL_GRAPHIC_TOPOLOGY,
  CHANGE_ACTIVE_ITEM_PROTOCOL_LOG,
  // ----------------------- Physical Medium DP ----------------------------
  CHANGE_ACTIVE_ITEM_DN_LIVELIST,
  CHANGE_ACTIVE_ITEM_DN_LIVELIST_MATRIX,
  CHANGE_ACTIVE_ITEM_DN_OSCILLOSCOPE,
  CHANGE_ACTIVE_ITEM_DN_BAR_GRAPH,
  CHANGE_ACTIVE_ITEM_DN_LOG,
  // ----------------------- Config Route ----------------------------
  CHANGE_ROUTE
} from "actions/types";

// ---------------------------- Actions ----------------------------
export function tsExpertAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_TS_EXPERT,
    payload: { activeItem: "/" }
  };
}

export function configAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_CONFIG,
    payload: { activeItem: "/config" }
  };
}

// ----------------------- Protocol ----------------------------
export function protocolResumeAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_PROTOCOL_RESUME,
    payload: { activeItem: "/protocol-resume" }
  };
}

export function protocolLivelistAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_PROTOCOL_LIVELIST,
    payload: { activeItem: "/protocol-livelist" }
  };
}

export function protocolLiveListMatrixAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_PROTOCOL_LIVELIST_MATRIX,
    payload: { activeItem: "/protocol-livelist-matrix" }
  };
}

export function protocolGraphicTopologyAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_PROTOCOL_GRAPHIC_TOPOLOGY,
    payload: { activeItem: "/protocol-graphic-topology" }
  };
}

export function protocolLogAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_PROTOCOL_LOG,
    payload: { activeItem: "/protocol-log" }
  };
}

// ----------------------- Physical Medium DP ----------------------------
export function dnLiveListAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_DN_LIVELIST,
    payload: { activeItem: "/dn-live-list" }
  };
}

export function dnLiveListMatrixAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_DN_LIVELIST_MATRIX,
    payload: { activeItem: "/dn-live-list-matrix" }
  };
}

export function dnOscilloscopeAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_DN_OSCILLOSCOPE,
    payload: { activeItem: "/dn-oscilloscope" }
  };
}

export function dnBarGraphAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_DN_BAR_GRAPH,
    payload: { activeItem: "/dn-bar-graph" }
  };
}

export function dnLogAction() {
  return {
    type: CHANGE_ACTIVE_ITEM_DN_LOG,
    payload: { activeItem: "/dn-log" }
  };
}

// ----------------------- Solve Problem ----------------------------
export function solveProblemAction(solve, problem) {
  return {
    type: SOLVE_PROBLEM,
    payload: {
      solve: solve,
      problem: problem
    }
  };
}

// ----------------------- Change Route ----------------------------
export function changeRouteAction(currGenConfigComponent, currProtConfigComponent, currAnDPConfigComponent) {
  return {
    type: CHANGE_ROUTE,
    payload: {
      currGenConfigComponent: currGenConfigComponent,
      currProtConfigComponent: currProtConfigComponent,
      currAnDPConfigComponent: currAnDPConfigComponent
    }
  };
}